// Add a cabinet to a store (before its sensor): name, type (Retail set's
// cabinet_type values, in the person's language), temperature regime.
import { useState } from "preact/hooks";
import { classKeys, clsName } from "../data/classes";
import { useT } from "../i18n";
import { tenantApi } from "../lib/account";
import { useLoad } from "../lib/load";
import { loadFleet } from "../data/fleet";
import { addCabinet } from "../data/cabinets";
import { errText } from "../lib/apierr";

export function AddCabinetDialog({ site, account, onClose }: { site: string; account: string; onClose: (done: boolean) => void }) {
  const t = useT();
  const def = useLoad(() => tenantApi<{ enum_values?: string[]; value_labels?: Record<string, string> }>("GET", `/property-defs/cabinet_type?lang=${t.lang}`).catch(() => ({ enum_values: [] as string[], value_labels: {} as Record<string, string> })), [t.lang]);
  const [f, setF] = useState({ name: "", type: "", regime: "frozen" });
  const [err, setErr] = useState("");
  const save = async (e: Event) => {
    e.preventDefault(); setErr("");
    try { await addCabinet({ site, account_id: account, ...f }); await loadFleet(t.lang); onClose(true); } catch (x) { setErr(errText(t, x)); }
  };
  return (
    <div class="modal" onClick={(e) => e.target === e.currentTarget && onClose(false)}>
      <form class="box card" style="width:min(520px,100%)" onSubmit={save}>
        <h2 style="margin:0">{t("x.cab.add")}</h2>
        <p style="margin:0;color:var(--muted)">{t("x.cab.addText")}</p>
        <label class="f">{t("x.inst.cabinet")}<input required value={f.name} placeholder="FI-03" onInput={(e) => setF({ ...f, name: (e.target as HTMLInputElement).value })} /></label>
        <label class="f">{t("x.cab.type")}<select value={f.type} onChange={(e) => setF({ ...f, type: (e.target as HTMLSelectElement).value })}><option value="">—</option>{(def.data?.enum_values || []).map((v) => <option key={v} value={v}>{(def.data?.value_labels as Record<string, string> | undefined)?.[v] || v}</option>)}</select></label>
        <label class="f">{t("x.regime")}<select value={f.regime} onChange={(e) => setF({ ...f, regime: (e.target as HTMLSelectElement).value })}>{classKeys().map((r) => <option key={r} value={r}>{clsName(t.lang, r)}</option>)}</select></label>
        {err && <p class="st st-crit" style="margin:0">{err}</p>}
        <div class="row" style="justify-content:flex-end"><button class="btn" type="button" onClick={() => onClose(false)}>{t("alm.cancel")}</button><button class="btn pri" type="submit">{t("x.cab.add")}</button></div>
      </form>
    </div>
  );
}
